<template>
    <div>
        <template v-if="currentUser.role.includes('head-accountant') || 
                        currentUser.role.includes('accountant')">
            <div class="accountant-dashboard">
                <!-- HERO -->
                <b-card class="dashboard-hero-card mb-4" body-class="p-4 p-md-5">
                    <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between">
                        <div class="mb-3 mb-md-0">
                            <h2 class="mb-2 text-white accountant-title">
                                <span class="accountant-emoji">🧮</span>
                                Я БУХГАЛТЕР, МНЕ МОЖНО
                            </h2>
                            <p class="lead text-white-80 mb-0 accountant-subtitle">{{ generateWelcomeBuhMessage() }}</p>
                        </div>
                        <div class="text-nowrap hero-actions text-right">
                            <div class="accountant-badge">
                                <i class="fas fa-calculator"></i>
                                <span>Бухгалтерия</span>
                            </div>
                        </div>
                    </div>
                </b-card>

                <!-- Дополнительная информация -->
                <b-row>
                    <b-col cols="12" md="8">
                        <b-card class="mb-4">
                            <h4 class="card-title mb-3">💼 Ваши возможности:</h4>
                            <ul class="list-unstyled">
                                <li class="mb-2">
                                    <i class="fas fa-chart-line text-success mr-2"></i>
                                    <strong>Финансовая аналитика:</strong> Полный доступ к отчетам и статистике
                                </li>
                                <li class="mb-2">
                                    <i class="fas fa-file-invoice-dollar text-success mr-2"></i>
                                    <strong>Управление счетами:</strong> Контроль всех финансовых операций
                                </li>
                                <li class="mb-2">
                                    <i class="fas fa-users text-success mr-2"></i>
                                    <strong>Работа с агентами:</strong> Настройка комиссий и выплат
                                </li>
                            </ul>
                        </b-card>
                    </b-col>

                    <b-col cols="12" md="4">
                        <!-- <b-card class="mb-4">
                            <h5 class="card-title mb-3">🎯 Статус дня:</h5>
                            <div class="day-status">
                                <div class="status-item">
                                    <i class="fas fa-sun text-warning"></i>
                                    <span>Хорошего дня!</span>
                                </div>
                            </div>
                        </b-card> -->

                        <b-card>
                            <h5 class="card-title mb-3">📊 Быстрый доступ:</h5>
                            <div class="quick-access-buttons">
                                <b-button variant="outline-primary" to="/finance" size="lg" class="mb-3 w-100 accountant-btn">
                                    <i class="fas fa-chart-bar mr-2"></i>
                                    Финансы
                                </b-button>
                                <b-button variant="outline-success" to="/finance/payments" size="lg" class="mb-3 w-100 accountant-btn">
                                    <i class="fas fa-money-bill-wave mr-2"></i>
                                    Платежи
                                </b-button>
                                <b-button variant="outline-info" to="/finance/requests" size="lg" class="mb-3 w-100 accountant-btn">
                                    <i class="fas fa-calculator mr-2"></i>
                                    Запросы
                                </b-button>
                            </div>
                        </b-card>

                    </b-col>
                </b-row>
            </div>
        </template>
        <template v-if="underConstruction || currentUser.role.includes('b2c-head-manager') || currentUser.role.includes('b2c-manager')">
            <b-jumbotron>
                <template #header>
                    <h3 class="display-4">Раздел в разработке</h3>
                </template>
            
                <template #lead>
                  Дашборд временно недоступен. Создается версия 2.0.
                </template>
            
                <hr class="my-4">
            
                <p>
                  Запуск запланирован на 2025 год. 
                </p>
            
            </b-jumbotron>            
        </template>        
        <template v-if="!underConstruction && 
                        !currentUser.role.includes('b2c-head-manager') && 
                        !currentUser.role.includes('b2c-manager') && 
                        !currentUser.role.includes('head-accountant') && 
                        !currentUser.role.includes('accountant')">
            <div class="d-flex justify-content-space-between mt-2 mb-4">
                <div 
                    class="title-of-dashboard"
                >
                    <h5 class="mb-0 pr-3">{{ welcomeMessage }}</h5>
                </div>
                <div class="d-flex" style="justify-content: space-between;">
                    <div class="d-flex green-filter">
                        <!-- <span 
                            v-if="salesHead || toHead"
                            :disabled="updatingData" 
                            v-for="(item, index) in greenFilterMenu" 
                            :key="index" 
                            :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                            @click="changePeriod(index, item.type)"
                        >
                            {{ item.title }}
                        </span> -->
                    </div>
                    <div class="d-flex">
                        <div class="d-flex green-filter" v-if="administrators">
                            <span 
                                :disabled="updatingData" 
                                v-for="(item, index) in departmentMenu" 
                                :key="index" 
                                :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" 
                                style="height: 28px;"
                                @click="changeDepartment(index, item.type)"
                            >
                                {{ item.title }}
                            </span>
                        </div>
                        <b-button
                            size="sm"
                            variant="reload"
                            class="ml-2"
                            title="Обновиться"
                            @click="updatingData = true"
                        >
                            Обновить<b-icon icon="arrow-repeat" scale="1.5" aria-label="Reload" class="ml-2" :animation="updatingData ? 'spin' : ''"></b-icon>
                        </b-button>            
                    </div>
                </div>
            </div>
            <template v-if="salesHead && departmentMenuActive == 'sales'">
                <SalesHeadDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></SalesHeadDashboard>
            </template>
            <template v-if="administrators && departmentMenuActive == 'sales'">
                <SalesHeadDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></SalesHeadDashboard>
            </template>
            <template v-if="toHead && departmentMenuActive == 'TO'">
                <ToHeadDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></ToHeadDashboard>
            </template>
            <template v-if="logisticHead && departmentMenuActive == 'logistic'">
                <LogisticHeadDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></LogisticHeadDashboard>
            </template>
            <template v-if="administrators && departmentMenuActive == 'TO'">
                <ToPresidentDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></ToPresidentDashboard>
            </template>
            <template v-if="administrators && departmentMenuActive == 'logistic'">
                <LogisticPresidentDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></LogisticPresidentDashboard>
            </template>
            <template v-if='currentUser.role.includes("sales-manager")'>
                <SalesDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></SalesDashboard>
            </template>
            <template v-if='currentUser.role.includes("TO-manager") || currentUser.role.includes("bsz-manager")'>
                <ToDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></ToDashboard>
            </template>
            <template v-if='currentUser.role.includes("logistics-manager")'>
                <LogisticDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></LogisticDashboard>
            </template>
            <template v-if='currentUser.role.includes("b2c-head-manager") || currentUser.role.includes("b2c-manager")'>
                <B2cDashboard
                    :noNames="true"
                    :loading="updatingData"
                    @isUpdated="isUpdated"
                ></B2cDashboard>
            </template>
        </template> 
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SalesDashboard from '@components/dashboards/SalesDashboard';
import SalesHeadDashboard from '@components/dashboards/SalesHeadDashboard';
import ToHeadDashboard from '@components/dashboards/ToHeadDashboard';
import ToPresidentDashboard from '@components/dashboards/ToPresidentDashboard';
import ToDashboard from '@components/dashboards/ToDashboard';
import LogisticHeadDashboard from '@components/dashboards/LogisticHeadDashboard';
import LogisticPresidentDashboard from '@components/dashboards/LogisticPresidentDashboard';
import LogisticDashboard from '@components/dashboards/LogisticDashboard';
import B2cDashboard from '@components/dashboards/B2cDashboard';
import DashboardAgent from '@components/dashboards/DashboardAgent';

export default {
    components: {
        SalesHeadDashboard,
        SalesDashboard,
        ToHeadDashboard,
        ToPresidentDashboard,
        ToDashboard,
        LogisticHeadDashboard,
        LogisticPresidentDashboard,
        LogisticDashboard,
        B2cDashboard,
        DashboardAgent
    },
    data() {
        return {
            underConstruction: false,
            welcomeMessage: 'Ваш персональный Dashboard',
            updatingData: true,
            greenFilterMenu: [
                {title: 'Сегодня', type: 'today', active: true},
                {title: 'Неделя', type: 'week', active: false},
                {title: 'Месяц', type: 'month', active: false},
                {title: 'Год', type: 'year', active: false}
            ],
            departmentMenu: [
                {title: 'Продажи', type: 'sales', active: false},
                {title: 'ТО', type: 'TO', active: true},
                {title: 'ТЭО', type: 'logistic', active: false},
            ],
            departmentMenuActive: 'TO',
            period_start: '',
            period_end: '',
        }
    },

    computed: {
        ...mapGetters('auth', ['currentUser']),

        salesHead() {
            return (
                this.currentUser.role.includes("sales-head-manager")
            );
        }, 
        
        toHead() {
            return (
                this.currentUser.role.includes("TO-head-manager")
            );
        }, 

        logisticHead() {
            return (
                this.currentUser.role.includes("logistics-head-manager")
            );
        }, 

        administrators() {
            return (
                this.currentUser.role.includes("president") ||
                this.currentUser.role.includes("administrator")
            );
        },        
    },    
    mounted() {
        this.generateWelcomeMessage();

        if (this.toHead) {
            this.departmentMenuActive = 'TO';
        }
        if (this.logisticHead) {
            this.departmentMenuActive = 'logistic';
        }
        if (this.administrators) {
            this.departmentMenuActive = 'TO';
        }
        if (this.salesHead) {
            this.departmentMenuActive = 'sales';
        }
    },
    methods: {
        generateWelcomeMessage() {
            let min = 1;
            let max = 5;
            let numb = Math.floor(Math.random() * (max - min + 1)) + min;
            switch (numb) {
                case 1:
                    this.welcomeMessage = 'Dashboard: Возможности не приходят сами — вы создаете их. Хорошего дня!';
                    break;
                case 2:
                    this.welcomeMessage = 'Ваш персональный Dashboard желает вам хорошего дня!';
                    break;
                case 3:
                    this.welcomeMessage = 'Dashboard: Лучший способ взяться за что-то — перестать говорить и начать делать.';
                    break;
                case 4:
                    this.welcomeMessage = 'Dashboard: Многое кажется невозможным, пока ты этого не сделаешь.';
                    break;
                case 5:
                    this.welcomeMessage = 'Dashboard: Великие дела нужно совершать, а не обдумывать их бесконечно.';
                    break;
                default:
                    this.welcomeMessage = 'Ваш персональный Dashboard';
                    break;
            }
        },  
        generateWelcomeBuhMessage() {
            let min = 1;
            let max = 5;
            let numb = Math.floor(Math.random() * (max - min + 1)) + min;
            switch (numb) {
                case 1:
                    return "Бухгалтер – это мастер точности и порядка, который всегда находит правильное решение даже в самых сложных финансовых ситуациях.";
                    break;
                case 2:
                    return "Бухгалтер – единственный человек в офисе, который знает, сколько стоит утренний кофе каждому сотруднику… с точностью до копейки.";
                    break;
                case 3:
                    return "Талант бухгалтера заключается не только в вычислениях, но и в умении обеспечить финансовую безопасность и стабильность.";
                    break;
                case 4:
                    return "Бухгалтер – это человек, который делает работу с финансами понятной и управляемой, создавая основу для роста и развития.";
                    break;
                case 5:
                    return "С хорошим бухгалтером компания чувствует уверенность в завтрашнем дне, ведь каждый отчёт подготовлен с особой тщательностью и заботой.";
                    break;
                default:
                    return "Хороший бухгалтер – это не просто магистр точности, это человек, который может объяснить, почему деньги улетели быстрее, чем хотелось бы.";
                    break;
            }
        },
        isUpdated() {
            this.updatingData = false;
        },
        changePeriod(activeIndex, period) {
            this.greenFilterMenu.forEach((item, index) => {
                item.active = false
                if (activeIndex == index) {
                    item.active = true
                    switch (period) {
                        case 'today':
                            this.period_start = this.$moment.utc().local().format('YYYY-MM-DD') //текущая дата
                            this.period_end = ''
                            this.updatingData = true;
                            break;
                        case 'week':
                            let now = this.$moment();
                            let monday = now.clone().weekday(0);
                            this.period_start = monday.format('YYYY-MM-DD') //первый день недели
                            this.period_end = ''
                            this.updatingData = true;
                            break;
                        case 'month':
                            let startOfMonth = this.$moment().startOf('month').format('YYYY-MM-DD');
                            this.period_start = startOfMonth //первый день месяца
                            this.period_end = ''
                            this.updatingData = true;
                            break;
                        case 'year':
                            let startOfYear = this.$moment().startOf('year').format('YYYY-MM-DD');
                            this.period_start = startOfYear //первый день года
                            this.period_end = ''
                            this.updatingData = true;
                            break;
                    }
                }
            })
        },
        changeDepartment(activeIndex, department) {
            this.departmentMenu.forEach((item, index) => {
                item.active = false
                if (activeIndex == index) {
                    item.active = true;
                    this.departmentMenuActive = department;
                    this.updatingData = true;
                }
            })
        },
    }
}
</script>
<style>
.title-of-dashboard {
    flex-direction: row; 
    align-items: center; 
    justify-content: space-between; 
    align-content: center; 
    flex-wrap: nowrap;
}

/* Стили для бухгалтерской шапки */
.accountant-dashboard {
    max-width: 100%;
}

.dashboard-hero-card {
    background: linear-gradient(135deg, #0d6348 0%, #e37926 100%);
    border: none;
    color: #fff;
    border-radius: 14px;
    position: relative;
    overflow: hidden;
}

.dashboard-hero-card::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    animation: shimmer 3s ease-in-out infinite;
}

@keyframes shimmer {
    0%, 100% { transform: translateX(-100%) translateY(-100%) rotate(0deg); }
    50% { transform: translateX(100%) translateY(100%) rotate(180deg); }
}

.text-white-80 { 
    color: rgba(255, 255, 255, 0.85); 
}

.accountant-title {
    font-size: 2.5rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    animation: titleGlow 2s ease-in-out infinite alternate;
}

@keyframes titleGlow {
    0% { 
        text-shadow: 0 0 10px rgba(255,255,255,0.3);
    }
    100% { 
        text-shadow: 0 0 20px rgba(255,255,255,0.6), 0 0 30px rgba(255,255,255,0.3);
    }
}

.accountant-emoji {
    font-size: 3rem;
    margin-right: 15px;
    animation: bounce 2s ease-in-out infinite;
    display: inline-block;
}

@keyframes bounce {
    0%, 20%, 50%, 80%, 100% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-10px);
    }
    60% {
        transform: translateY(-5px);
    }
}

.accountant-subtitle {
    font-size: 1.1rem;
    line-height: 1.4;
    animation: fadeInUp 1s ease-out 0.5s both;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.accountant-badge {
    background: rgba(255, 255, 255, 0.15);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 25px;
    padding: 12px 20px;
    color: white;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    backdrop-filter: blur(10px);
    animation: badgePulse 2s ease-in-out infinite;
}

@keyframes badgePulse {
    0%, 100% {
        transform: scale(1);
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
    }
    50% {
        transform: scale(1.05);
        box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
    }
}

.accountant-badge i {
    margin-right: 8px;
    font-size: 1.1rem;
}

.quick-access-buttons .btn {
    transition: all 0.3s ease;
    border-radius: 12px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    padding: 12px 20px;
    border-width: 2px;
    position: relative;
    overflow: hidden;
}

.quick-access-buttons .btn::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.5s;
}

.quick-access-buttons .btn:hover::before {
    left: 100%;
}

.quick-access-buttons .btn:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0,0,0,0.2);
    border-width: 2px;
}

.accountant-btn {
    min-height: 50px;
    font-size: 0.95rem;
}

.accountant-btn i {
    font-size: 1.1rem;
}

.day-status {
    text-align: center;
    padding: 20px 0;
}

.status-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    font-weight: 600;
    color: #495057;
}

.status-item i {
    margin-right: 10px;
    font-size: 1.3rem;
    animation: sunRotate 4s linear infinite;
}

@keyframes sunRotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

/* Адаптивность */
@media (max-width: 768px) {
    .accountant-title {
        font-size: 2rem;
    }
    
    .accountant-emoji {
        font-size: 2.5rem;
        margin-right: 10px;
    }
    
    .accountant-badge {
        padding: 10px 16px;
        font-size: 0.9rem;
    }
}
</style>